import type { FormikConfig } from 'formik';
import type { ModalData } from '../Modal';

export interface ApplicationMessageModalFormValues {
  message: string;
}

export interface ApplicationMessageModalData {
  modal: ModalData;
  form: {
    initialValues: ApplicationMessageModalFormValues;
    onSubmit: (values: ApplicationMessageModalFormValues) => void;
    validate: FormikConfig<ApplicationMessageModalFormValues>['validate'];
  };
}

export interface ApplicationMessageModalProps extends ApplicationMessageModalData {}
